PF.ListCrudPage.Add = class Add extends PF.Trait
	{
	initTrait()
		{
		this.dom.add.show();
		this.dom.add.on('click', () => this.addItem());
		}

	addItem()
		{
		app.pageParams.setData(this.models.idIndex, null);
		app.router.navigate(this.editPage);
		}


	};